import React from 'react';
import SingleProforma from '../../components/client/SingleProforma'

const SingleProformaPage=()=> {
	return <SingleProforma />;
}
export default SingleProformaPage;
